import HttpRequest from './httpRequest'

export default class UserProvider extends HttpRequest {
  fetchProfile () {
    return this.fetch('/users')
  }

  createLineOfficialAccounts (params) {
    return this.create('/users/line-official-accounts', params)
  }

  updateBatchHideLineOfficialAccount (params) {
    return this.update('/line-official-accounts/batch-hide', params)
  }
}
